"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Venerdì",
    "MONDAY": "Lunedi",
    "SATURDAY": "Sabato",
    "SUNDAY": "Domenica",
    "THURSDAY": "giovedi",
    "TUESDAY": "martedì ",
    "WEDNESDAY": "mercoledì",
    "and": "e",
    "day": "giorno",
    "day_many": "giorni",
    "day_one": "giorno",
    "day_other": "giorni",
    "day_plural": "giorni",
    "freeOfCharge": "Gratuito",
    "hour_one": "ora",
    "hour_one_plural": "ore",
    "hour_other": "ore",
    "minute": "minuto ",
    "minute_many": "minuto ",
    "minute_one": "minuto ",
    "minute_other": "minuti ",
    "ocpiRestrictionsAfterDuration": "Dopo {{minDuration}} ",
    "ocpiRestrictionsBetweenDuration": "Tra {{minDuration}} e {{maxDuration}} ",
    "ocpiRestrictionsFirstDuration": "Primo {{maxDuration}} ",
    "ocpiRestrictionsKwhAbove": "Quando il consumo di energia è superiore a {{minKwh}} ",
    "ocpiRestrictionsKwhBetween": "Quando il consumo di energia è compreso tra {{minKwh}} e {{maxKwh}} ",
    "ocpiRestrictionsKwhLessThan": "Quando il consumo di energia è inferiore a {{maxKwh}} ",
    "session": "sessione",
    "theDay_many": "giorno",
    "theDay_one": "giorno",
    "theDay_other": "giorni",
    "theHour_many": "ora",
    "theHour_one": "ora",
    "theHour_other": "ore",
    "theMinute_many": "minuto ",
    "theMinute_one": "minuto ",
    "theMinute_other": "minuti "
};
